import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/lib/api'

/** A 4xx is a verdict (404, 403, a taken slug), not a flaky network: show it at once. */
function retry(failureCount: number, error: Error): boolean {
  return failureCount < 2 && !(error instanceof ApiError && error.status < 500)
}

/**
 * 2026-09-12 locks: the shell gate reads the cached restaurant context, so a lock that lands
 * while a page is open surfaces on the next refused request by refetching that context.
 */
function refreshLockedContext(error: Error): void {
  if (error instanceof ApiError && (error.code === 'RESTAURANT_DEACTIVATED' || error.code === 'BRANCH_CLOSED')) {
    void queryClient.invalidateQueries({ queryKey: ['back-office', 'context'] })
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: refreshLockedContext }),
  mutationCache: new MutationCache({ onError: refreshLockedContext }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry,
      refetchOnWindowFocus: true,
    },
  },
})
